/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('tableView', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/table-view.html'),

      replace: true,

      scope: {
        data: '=ngModel',
      },

      link(scope, element, attrs) {},
    };
  },
]);
